// import { Vue, Component } from "vue-property-decorator";
import vCarousel from '@/components/slider_ah/v-carousel.vue';
import vAccordion from '@/components/accordion/v-accordion.vue';
// import vSliderControls from '@/components/slider_ah/v-slider-controls.vue';
import RequestButtonFxd from '@/components/request-button/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';
import TrialButton from '@/components/trial-button/index.vue';
import FreeProducts from '@/components/products/parts/free-products.vue';

// import user_module from '@/modules/user/index';


export default  {
 name: 'NewLexe',
 components: {
  RequestButtonFxd,
  RequestButton,
  TrialButton,
  FreeProducts,
  vCarousel,
  vAccordion
  // vSliderControls
 },
 data(){
  return{
   img: {
    lexe_main_scr: require("@/landings/LE_NEW/1-min.png"),
    sell_more: require("@/landings/LE_NEW/sell-more.svg"),
    save_time: require("@/landings/LE_NEW/save-time.svg"),
    mailing_service: require("@/landings/LE_NEW/mailing-service.svg"),
    letter_templates: require("@/landings/LE_NEW/letter-templates.svg"),

   },
   slides:[
    "https://picsum.photos/id/10/1250/833",
    "https://picsum.photos/id/0/1250/833",
    "https://picsum.photos/id/100/1250/833",
    "https://picsum.photos/id/1001/1250/833",
    "https://picsum.photos/id/1002/1250/833",
   ],

   newslides: [ 
    {
     id: 1, 
     name: 'Valeri Bishop',
     testimonial: 'Our firm can not only provide excellent plan governance but the cost sayings can be truly eye opening. Builds credibility with your strategic partners and enhances referrals. Also the support has been amazing when I have questions, response is outstanding!',
     post:'AIF',
     img: require("@/landings/LE_NEW/valerib.jpg"),     
    },
    {
     id: 2, 
     name: 'Alexander Pasquale',
     testimonial: 'RiXtrema is by far the best product for RIAs who want to win retirement plan business. As one prospect put it ‘this is the best presentation they have ever seen’. Since we purchased the product in July we have well over 20 solid leads and some have already closed.',
     post:'President of the Everest Consultants, LLC',
     img: require("@/landings/LE_NEW/apas.jpg"),     
    },
    {
     id: 3, 
     name: 'Greg Hicks',
     testimonial: 'I wanted to give a recommendation to the group at Rixtrema! We’ve worked together adding a few personalized features to the web site and the service has been outstanding. The web site has allowed me to double my prospecting efforts.',
     post:'CRPC® Vice President – Investments',
     img: require("@/landings/LE_NEW/greghicks.jpg") ,     
    },  
   ],
   sign:{
    one: require("@/landings/LE_NEW/sign.svg"),
    
   },

   props_items:[
    {
     id:1,
     img:require("@/landings/LE_NEW/high-roi-process.svg"),
     title:'High ROI Process:',
     descr:'LE does the job of a salesperson knowledgeable in qualified plans'
    },
    {
     id:2,
     img:require("@/landings/LE_NEW/analyze-and-win.svg"),
     title:'Analyze & Win Any Plan Today!',
     descr:'Detailed Intelligence on 850,000+ Retirement Plans'
    },    
    {
     id:3,
     img:require("@/landings/LE_NEW/reach-out-to.svg"),
     title:'Reach Out To Decision Makers',
     descr:'Over 1.2 Million Plan Executives With Contact Info'
    },
    {
     id:4,
     img:require("@/landings/LE_NEW/be-the-first-one.svg"),
     title:'Be the First One to Present',
     descr:'Real Time Plan Filing Update For You (While Others Wait)'
    },
    {
     id:5,
     img:require("@/landings/LE_NEW/improve-plan.svg"),
     title:'Improve Plan Investments',
     descr:'Menu Breakdown for 80,000+ Plans'
    },
    {
     id:6,
     img:require("@/landings/LE_NEW/sell-from-home.svg"),
     title:'Sell From Home on Autopilot:',
     descr:'LE sends automated email campaigns to plan sponsors'
    },
   ],
   show: false,

   faq: [
    {
      id:1,
      question: 'Why do we use it?',
      answer: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using "Content here, content here", making it look like readable English.'
    },
    {
      id:2,
      question: 'Why do we use it?',
      answer: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using "Content here, content here", making it look like readable English.'
    },
    {
      id:3,
      question: 'Why do we use it?',
      answer: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using "Content here, content here", making it look like readable English.'
    },
    {
      id:4,
      question: 'Why do we use it?',
      answer: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using "Content here, content here", making it look like readable English.'
    },
   ],


  }
 },
 methods: {
  accordion: function (event) {
    var matches = document.querySelectorAll('.accordion-item-head');
    for(var i = 0; i < matches.length; i++) {
     matches[i].classList.remove('active');
    }
     event.target.classList.toggle('active');
  }
}

}